// extracted by mini-css-extract-plugin
module.exports = {"image":"Thumbnail_image__eN4UX"};